import { cn } from "@/lib/utils";

export const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  submitted: "Under review",
  under_review: "Under review",
  changes_requested: "Changes requested",
  rejected: "Rejected",
  approved: "Approved",
  published: "Published",
  removed: "Removed",
  scheduled: "Scheduled",
};

const STATUS_TONE: Record<string, string> = {
  draft: "border-border/70 bg-surface text-muted-foreground",
  submitted: "border-primary/40 bg-primary/10 text-primary",
  under_review: "border-primary/40 bg-primary/10 text-primary",
  changes_requested: "border-amber-500/40 bg-amber-500/10 text-amber-500",
  rejected: "border-destructive/40 bg-destructive/10 text-destructive",
  approved: "border-emerald-500/40 bg-emerald-500/10 text-emerald-500",
  published: "border-emerald-500/40 bg-emerald-500/10 text-emerald-500",
  removed: "border-destructive/40 bg-destructive/10 text-destructive",
  scheduled: "border-border/70 bg-surface text-muted-foreground",
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        STATUS_TONE[status] ?? STATUS_TONE['draft'],
      )}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
